<template>
    <div>
        <Navigation :alwaysTop="true" />
        <slot v-if="hasBannerSlot" name="banner"></slot>
        <section v-else
            class="mm-section mm-section__banner"
            :style="{
                backgroundImage: `url(${image})`,
                maxHeight: '40rem'
            }">
            <div class="mm-section-content">
                <div class="mm-section__banner-headline">
                    <div class="mm-section__banner-subtitle">
                        {{title}}
                    </div>
                </div>
            </div>
        </section>
        <slot name="content"></slot>
        <section class="mm-section mm-section__space"></section>
        <app-footer />
  </div>
</template>


<script>
import Navigation from '@/components/ui/Navigation/Navigation';

export default {
    components: {
        Navigation
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,
            defaultImageName: this.$t('Layouts.Page.image')
        }
    },
    props: {
        imageName: {
            type: String,
            required: false
        },
        title: {
            type: String,
            required: false
        }
    },
    computed: {
        hasBannerSlot () {
            return !!this.$slots['banner']
        },
        image() {
            if (this.imageName) {
                return this.imageName;
            } else {
                return this.defaultImageName;
            }
        }
    }
}
</script>